import { createContext, useContext } from "react";
import { WatchdogRunSnapshot } from "./watchdogRun";
export const WATCHDOG_SPAWN_TOOL = "watch_release";

// One parse per raw object, so a report keeps its identity across renders
// and index rebuilds can tell "unchanged" from "changed" by reference.
const parsedByRaw = new WeakMap<object, WatchdogRunSnapshot | null>();

/**
 * The run a `watchdog_report` row shows: the backend's completion mirror
 * stamps it on the parent's row, and placeWatchdogCard on a watchdog
 * session's own placeholder row.
 */
export function watchdogReportMetadata(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): WatchdogRunSnapshot | null {
  if (message.role !== "agent") return null;
  const raw = message.metadata?.watchdog_report;
  if (typeof raw !== "object" || raw === null) return null;
  let parsed = parsedByRaw.get(raw);
  if (parsed === undefined) {
    const result = WatchdogRunSnapshot.safeParse(raw);
    parsed = result.success ? result.data : null;
    parsedByRaw.set(raw, parsed);
  }
  return parsed;
}

/** Display-only row, not a turn of this session: working-state and turn-anchoring scans skip it. */
export function isWatchdogReportMessage(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): boolean {
  return watchdogReportMetadata(message) !== null;
}

/** Per watchdog session: its latest run, live or mirrored. */
export type WatchdogRunsIndex = ReadonlyMap<string, WatchdogRunSnapshot>;
export const WatchdogRunsContext = createContext<WatchdogRunsIndex>(new Map());
export function useWatchdogRunsIndex() {
  return useContext(WatchdogRunsContext);
}